import React, { ReactElement } from 'react';
import AppLayout from 'components/layouts/AppLayout';
import { getGlobalProps } from 'utils/helpers/server/serverSideProps/global';
import { getPageProps } from 'utils/helpers/server/serverSideProps/ssrProps';
import { getPageNamespaces } from 'utils/helpers/server/serverSideProps/translations';
import { getTranslation, useTranslation } from 'utils/localization';
import { ServerSideInitProps, TNamespaceEnum } from 'types/types';
import DocumentsBlock from 'components/pages/documents/DocumentsBlock';
import {
    DOC_SET_QUERY_KEY,
    DocSetEnum,
} from 'components/pages/documents/documents.data';

interface Props {
    initialDocumentSet: DocSetEnum;
}

interface ServerSideProps {
    props?: Props;
}

const Page = ({ initialDocumentSet }: Props): ReactElement => {
    const { t } = useTranslation();

    return (
        <AppLayout
            title={getTranslation(t, TNamespaceEnum.navigation, 'pageTitle')}
            pageTitle={{
                primaryBoldText: getTranslation(
                    t,
                    TNamespaceEnum.navigation,
                    'documents'
                ),
                isDark: true,
            }}
            hideUserMenu
            showDisciplineMenu
            hideLoginAs
            changeDisciplineWithoutReload={true}
            showLangMenu={true}
        >
            <DocumentsBlock initialSet={initialDocumentSet} />
        </AppLayout>
    );
};

export const getServerSideProps = async ({
    req,
    res,
    query,
}: ServerSideInitProps): Promise<ServerSideProps> => {
    const { api } = await getGlobalProps(req, res, true);

    /*
        Sada se vyhodnotí už na serveru, aby server i klient renderovali totéž —
        žádné probliknutí české sady, žádný hydration mismatch. Neznámá hodnota
        (?set=de, ?set=EN, pole hodnot) padá na českou sadu.
     */
    const initialDocumentSet =
        query?.[DOC_SET_QUERY_KEY] === DocSetEnum.en
            ? DocSetEnum.en
            : DocSetEnum.cs;

    const props = await getPageProps<Props>({
        givenProps: { initialDocumentSet },
        res,
        req,
        api,
        query,
        loadUserData: false,
        translatePage: true,
        nameSpaces: getPageNamespaces('/navigation/documents'),
    });

    return {
        props,
    };
};

export default Page;
